import { computed } from "vue";

import { $t } from "@/i18n";
import { Routes } from "@/router";
import type { NavNode } from "@/utils/navUtils";

export function useTenantManagementNav() {
  return computed<NavNode>(() => ({
    label: $t("common.label.mandators"),
    icon: "phosphor/city",
    layoutStoreKey: "tenantManagement",
    route: { name: Routes.TENANT_MANAGEMENT },
  }));
}
